module.exports = __webpack_public_path__ + "img/leftBox1.c87a943d.png";